// Fence info strings: `name key=value key="quoted value"`.
const WS = /[ \t\r\n]/;
/**
 * Parse an info string. The first word is the component name; the rest are `key=value`
 * pairs. Values containing spaces are double-quoted; inside quotes `\"` and `\\` are escapes.
 * Bare words (no `=`) are kept as attrs with an empty value so schemas can report them.
 */
export function parseInfoString(info) {
    let i = 0;
    const n = info.length;
    const skipWs = () => {
        while (i < n && WS.test(info[i]))
            i++;
    };
    skipWs();
    let name = "";
    const nameStart = i;
    while (i < n && !WS.test(info[i])) {
        if (info[i] === "=")
            break;
        i++;
    }
    name = info.slice(nameStart, i);
    if (info[i] === "=") {
        // The first word is actually a key=value pair: there is no name.
        i = nameStart;
        name = "";
    }
    const nameEnd = nameStart + name.length;
    const tokens = [];
    const attrs = {};
    for (;;) {
        skipWs();
        if (i >= n)
            break;
        const start = i;
        while (i < n && !WS.test(info[i]) && info[i] !== "=")
            i++;
        const key = info.slice(start, i);
        if (info[i] !== "=") {
            tokens.push({ key, value: "", bare: true, quoted: false, start, end: i });
            if (key && !(key in attrs))
                attrs[key] = "";
            continue;
        }
        i++; // '='
        let value = "";
        let quoted = false;
        if (info[i] === '"') {
            quoted = true;
            i++;
            let closed = false;
            while (i < n) {
                const ch = info[i];
                if (ch === "\\" && i + 1 < n) {
                    value += info[i + 1];
                    i += 2;
                    continue;
                }
                if (ch === '"') {
                    i++;
                    closed = true;
                    break;
                }
                value += ch;
                i++;
            }
            if (!closed) {
                // Unterminated quote: take everything to the end.
            }
        }
        else {
            const vs = i;
            while (i < n && !WS.test(info[i]))
                i++;
            value = info.slice(vs, i);
        }
        tokens.push({ key, value, bare: false, quoted, start, end: i });
        if (key)
            attrs[key] = value;
    }
    return { name, nameStart, nameEnd, attrs, tokens };
}
function quoteValue(value) {
    if (value === "" || /[\s"=\\]/.test(value)) {
        return '"' + value.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
    }
    return value;
}
/**
 * Serialize deterministically: `name id=x key=value key="quoted value"`.
 * `id` always comes first; other keys keep the given order. Undefined/null values are skipped.
 */
export function serializeInfoString(name, attrs = {}) {
    const parts = [name];
    if (attrs.id !== undefined && attrs.id !== null)
        parts.push(`id=${quoteValue(String(attrs.id))}`);
    for (const [key, value] of Object.entries(attrs)) {
        if (key === "id" || value === undefined || value === null)
            continue;
        parts.push(`${key}=${quoteValue(String(value))}`);
    }
    return parts.join(" ");
}
//# sourceMappingURL=infostring.js.map